export const USER_STATUSES = {
  working: { id: 'working', label: 'Working', emoji: '🎬', color: 'transparent', isHidden: true, hasTimer: false },
  focus:   { id: 'focus',   label: 'Focus Mode', emoji: '🧠', color: '#8b5cf6', isHidden: false, hasTimer: true },
  rendering: { id: 'rendering', label: 'Rendering', emoji: '🔥', color: '#f97316', isHidden: false, hasTimer: true },
  lunch:   { id: 'lunch',   label: 'Lunch', emoji: '☕', color: '#eab308', isHidden: false, hasTimer: true },
  afk:     { id: 'afk',     label: 'AFK', emoji: '💤', color: '#6b7280', isHidden: false, hasTimer: true },
  meeting: { id: 'meeting', label: 'In a Meeting', emoji: '📅', color: '#3b82f6', isHidden: false, hasTimer: true },
  wrap:    { id: 'wrap',    label: "It's a wrap", emoji: '🏠', color: '#10b981', isHidden: false, hasTimer: false },
  beach:   { id: 'beach',   label: 'At the Beach', emoji: '🌴', color: '#0ea5e9', isHidden: false, hasTimer: false },
  sick:    { id: 'sick',    label: 'Sick', emoji: '🤒', color: '#ef4444', isHidden: false, hasTimer: false },
} as const;

export type UserStatusKey = keyof typeof USER_STATUSES;

export const USER_STATUS_KEYS = Object.keys(USER_STATUSES) as UserStatusKey[];

export function isValidStatusKey(key: string): key is UserStatusKey {
  return key in USER_STATUSES;
}

export function getStatusConfig(key: string | null | undefined) {
  if (!key || !isValidStatusKey(key)) return USER_STATUSES.working;
  return USER_STATUSES[key];
}
